/* unplugin-vue-components disabled */import { render } from "./extraContent.vue?vue&type=template&id=907c75d4&scoped=true"
import script from "./extraContent.vue?vue&type=script&lang=js"
export * from "./extraContent.vue?vue&type=script&lang=js"

import "./extraContent.vue?vue&type=style&index=0&id=907c75d4&scoped=true&lang=less"

import exportComponent from "/var/lib/jenkins/workspace/prod-fe.pro/src/fe-pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-907c75d4"]])

export default __exports__